import { Component, ViewChild, ElementRef } from '@angular/core';
import { LyTheme2 } from '@alyle/ui';
import { LyResizingCroppingImages, ImgCropperConfig, ImgCropperEvent } from '@alyle/ui/resizing-cropping-images';
import { styles } from './profile-crop-style';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-profile-crop',
  templateUrl: './profile-crop.component.html',
  styleUrls: ['./profile-crop.component.scss']
})
export class ProfileCropComponent {

  classes = this.theme.addStyleSheet(styles);
  croppedImg: string;
  @ViewChild(LyResizingCroppingImages, { static: false }) imgCropper: LyResizingCroppingImages;
  @ViewChild('_fileInput', { static: false }) myInputVariable: ElementRef;
  scale: number;
  fileValue: any;
  myConfig: ImgCropperConfig = {
    width: 150,
    height: 150,
    fill: '#ff2997'
  };

  constructor(
    private theme: LyTheme2,
    public dialogRef: MatDialogRef<ProfileCropComponent>
  ) { }

  ngOnInit() {
    this.croppedImg = '';
  }

  /** on event */
  onCrop(e: ImgCropperEvent) {
    this.croppedImg = e.dataURL;
    this.upload()
  }

  /** manual crop */
  getCroppedImg() {
    const img = this.imgCropper.crop();

    return img.dataURL;
  }

  clearImage(event) {

  }

  reset() {
    this.croppedImg = '';
    this.imgCropper.isCropped = false;

    this.myInputVariable.nativeElement.value = "";
  }

  upload() {
    let file = this.dataURLtoFile(this.croppedImg, 'profile.jpg');
    let obj = { file: file, status: true };
    this.dialogRef.close(obj);
    this.reset();
  }

  cancel() {
    this.reset();
    let obj = { file: '', status: true };
    this.dialogRef.close(obj);
  }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }


}




